import { OMNISEARCH_SET_SEARCH_TEXT } from '../../constants/actions';

const setSearchTextAction = (dispatch, searchText) =>
  dispatch({
    type: OMNISEARCH_SET_SEARCH_TEXT,
    payload: { searchText },
  });

export default (dispatch) =>
  ({ searchText }) =>
    setSearchTextAction(dispatch, searchText);
